"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleChartsLoader = void 0;
const scriptLibraryLoader_1 = require("../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
class GoogleChartsLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor() {
        super('GoogleCharts', constants_1.LOAD_CONFIG);
    }
    getUrls() {
        return [constants_1.URL];
    }
    postLoad() {
        return new Promise(resolve => {
            window.google.charts.load('current', {
                callback: resolve,
                packages: ['geochart'],
            });
        });
    }
}
exports.GoogleChartsLoader = GoogleChartsLoader;
//# sourceMappingURL=index.js.map